export const fontFamily = 'Monospace'
export const fontSize = 11

export const columnWidths = ['8%', '8%', '60%', '12%', '12%'] as const
